module.exports = __webpack_public_path__ + "img/graph1.e6de7dd0.svg";